import { useSelector } from 'react-redux'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useOfferFormKey = (): string => {
  const { getApplicationTypeFolder } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutes: {},
    loaderRoutesInsurance: {},
  })
  const { country } = useSelector(selectAuthData)

  return `${getApplicationTypeFolder().toLowerCase()}-${country?.toLowerCase()}`
}

export default useOfferFormKey
